import { cn } from '@brew/ui/cn'
import {
  ArrowUpRight,
  ChevronDown,
  ChevronUp,
  CircleCheck,
  Copy,
  type LucideIcon,
} from 'lucide-react'

type HandoffIconProps = {
  className?: string
}

/** The handoff card's glyphs share one weight, a touch lighter than lucide's 2. */
const HANDOFF_STROKE_WIDTH = 1.7

function Icon({
  glyph: Glyph,
  className,
}: HandoffIconProps & {
  glyph: LucideIcon
}) {
  return (
    <Glyph
      strokeWidth={HANDOFF_STROKE_WIDTH}
      className={cn('size-4', className)}
      aria-hidden="true"
    />
  )
}

export function HandoffChevronDownIcon(props: HandoffIconProps) {
  return <Icon glyph={ChevronDown} {...props} />
}

export function HandoffChevronUpIcon(props: HandoffIconProps) {
  return <Icon glyph={ChevronUp} {...props} />
}

export function HandoffExternalIcon(props: HandoffIconProps) {
  return <Icon glyph={ArrowUpRight} {...props} />
}

export function HandoffCheckIcon(props: HandoffIconProps) {
  return <Icon glyph={CircleCheck} {...props} />
}

export function HandoffCopyIcon(props: HandoffIconProps) {
  return <Icon glyph={Copy} {...props} />
}
